import styled from 'styled-components';

export const StyledServerAvailability = styled.span`
  position: absolute;
  right: 10px;
  font-size: 11px;
  font-weight: 400;
  color: ${(props) => (props.isFull ? '#ea4335' : '#34a853')};
`;
